<template>
  <div id="app">
    <app-header></app-header>
    <div class="app-content">
      <router-view/>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'app',
  components: { AppHeader, AppFooter },
};
</script>
<style lang="scss">
@import './assets/css/definitions';
*{
  padding: 0;
  margin: 0;
  font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-content {
  flex:1;
  width: 100%;
  text-align: center;
  background: $color-text-wh;
}

</style>

